const IN_APP_UA_PATTERN = /LinkedInApp|FBAN|FBAV|Instagram|Line\/|Twitter|Snapchat|; wv\)|\bwv\b/i;
const EXTERNAL_OPEN_ATTEMPT_KEY = 'persona_auth_external_open_attempted';

function isIosLinkedInLegacyWebView(userAgent, referrer) {
  const isIos = /iPhone|iPad|iPod/i.test(userAgent);
  if (!isIos || !/linkedin\.com/i.test(referrer || '')) {
    return false;
  }
  return (
    /AppleWebKit/i.test(userAgent) &&
    /Mobile\//i.test(userAgent) &&
    !/Safari\//i.test(userAgent) &&
    !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent)
  );
}

export function detectInAppBrowser(userAgent = '', referrer = '') {
  if (IN_APP_UA_PATTERN.test(userAgent)) {
    return true;
  }
  return isIosLinkedInLegacyWebView(userAgent, referrer);
}

export function isLinkedInInAppBrowser(userAgent = '', referrer = '') {
  if (/LinkedInApp/i.test(userAgent)) {
    return true;
  }
  if (/linkedin\.com/i.test(referrer || '') && /; wv\)|\bwv\b/i.test(userAgent)) {
    return true;
  }
  return isIosLinkedInLegacyWebView(userAgent, referrer);
}

export function openInExternalBrowser(url) {
  if (typeof window === 'undefined') {
    return;
  }
  const targetUrl = url || window.location.href;
  const userAgent = window.navigator.userAgent || '';
  const isAndroid = /Android/i.test(userAgent);
  const isIos = /iPhone|iPad|iPod/i.test(userAgent);

  if (isIos && isLinkedInInAppBrowser(userAgent, document.referrer || '')) {
    window.location.href = `x-safari-${targetUrl}`;
    return;
  }
  if (isAndroid) {
    const parsedUrl = new URL(targetUrl);
    const intentUrl = `intent://${parsedUrl.host}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}#Intent;scheme=${parsedUrl.protocol.replace(':', '')};package=com.android.chrome;end`;
    window.location.href = intentUrl;
    return;
  }
  window.open(targetUrl, '_blank', 'noopener,noreferrer');
}

export function tryAutoOpenAuthInExternalBrowser() {
  if (typeof window === 'undefined') {
    return;
  }
  if (!window.location.pathname.includes('/auth')) {
    return;
  }
  if (sessionStorage.getItem(EXTERNAL_OPEN_ATTEMPT_KEY)) {
    return;
  }
  const userAgent = window.navigator.userAgent || '';
  const referrer = document.referrer || '';
  if (!isLinkedInInAppBrowser(userAgent, referrer)) {
    return;
  }
  sessionStorage.setItem(EXTERNAL_OPEN_ATTEMPT_KEY, '1');
  openInExternalBrowser(window.location.href);
}
